<template>
  <page-view title="免单商品列表">
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="MianDan"></demo-video-alert>
    </div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择" allowClear>
                  <a-select-option value="1">商品标题</a-select-option>
                  <a-select-option value="2">商品ID</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询关键字">
                <a-input v-model="queryParam.keywords" placeholder="请输入" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="电商平台">
                <a-select v-model="queryParam.item_type" placeholder="请选择" allowClear>
                  <a-select-option value="1">淘宝</a-select-option>
                  <a-select-option value="2">京东</a-select-option>
                  <a-select-option value="3">拼多多</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced"></template>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button type="primary" @click="$refs.goodsAddModal.show()">新增免单商品</a-button>
      </div>
      <s-table ref="table" size="default" rowKey="id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <!-- <span slot="goods_img" slot-scope="text, record">
          <a-avatar shape="square" icon="picture" :src="record.image_url | goodsImg" />
        </span> -->
        <span slot="goods_img" slot-scope="text, record">
          <a-popover title="商品主图">
            <template slot="content">
              <img :src="record.image_url | goodsImg" style="max-width:200px" />
            </template>
            <a-avatar shape="square" icon="picture" :src="record.image_url | goodsImg" />
          </a-popover>
        </span>
        <span slot="goods_title" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <a v-line-clamp="1">{{ text }}</a>
          </a-tooltip>
        </span>
        
        <span slot="goods_id" slot-scope="text">{{ text }}</span>
        <span slot="item_type" slot-scope="text">{{ text | goodsPlatform }}</span>
        <span slot="price" slot-scope="text">{{ text | currency('￥') }}</span>
        <span slot="real_price" slot-scope="text">{{ text | currency('￥') }}</span>
        <span slot="create_time" slot-scope="text">{{ text }}</span>
        <span slot="action" slot-scope="text, record">
          <a-popconfirm placement="top" @confirm="handleDelete(record.id)">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <template slot="title">
              <p>确定要删除？</p>
            </template>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>
    </a-card>
    <goods-add-modal ref="goodsAddModal" @ok="$refs.table.refresh()"></goods-add-modal>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import ActivityApi from '@/api/activity'
import { PageView } from '@/layouts'
import GoodsAddModal from './modules/GoodsAddModal'
import { mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
export default {
  name: 'ActivityGoodslist',
  components: {
    PageView,
    STable,
    GoodsAddModal,
    DemoVideoAlert
  },
  data() {
    return {
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'serial' },
          width: 80
        },
        {
          title: '商品图片',
          scopedSlots: { customRender: 'goods_img' },
          width: 100,
          dataIndex: 'goods_img'
        },
        {
          title: '电商平台',
          scopedSlots: { customRender: 'item_type' },
          width: 100,
          dataIndex: 'item_type'
        },
        {
          title: '商品ID',
          scopedSlots: { customRender: 'goods_id' },
          width: 150,
          dataIndex: 'item_id'
        },
        {
          title: '商品标题',
          scopedSlots: { customRender: 'goods_title' },
          dataIndex: 'title'
        },
        {
          title: '现价',
          scopedSlots: { customRender: 'price' },
          width: 150,
          sorter: true,
          dataIndex: 'price'
        },
        {
          title: '实付价格',
          scopedSlots: { customRender: 'real_price' },
          width: 150,
          sorter: true,
          dataIndex: 'real_price'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 200,
          scopedSlots: { customRender: 'create_time' }
        },
        {
          title: '操作',
          width: '80px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return ActivityApi.getGoodsList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  filters: {
    goodsImg(str) {
      const arr = str.split(',')
      return arr[0]
    },
    goodsPlatform(str) {
      if (str == 1) {
        return '淘宝'
      } else if (str == 2) {
        return '京东'
      } else if (str == 3) {
        return '拼多多'
      }
    }
  },
  created() {},
  methods: {
    ...mapActions(['demoSetVideo']),
    handleDelete(id) {
      let loading = this.$message.loading('正在删除')
      ActivityApi.removeGoods([id])
        .then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    }
  }
}
</script>
<style lang="less" scoped></style>
